import { Button } from "../partials/buttons";
import globals from "../partials/global-variables";
import stylesConfig from "../styles.config";

const columnGap = 16; // some value which is good to divide by 2

export default {
  container: {
    "& .question-validation-message": {
      fontSize: stylesConfig.typography.fontSize(0.9),
      fontWeight: 400,
    },
    "& p": {
      margin: "0 0 2px",
      fontSize: stylesConfig.typography.fontSize(0.8),
      color: stylesConfig.colors.primaryAccentColorVariants.gray,
      width: "100%",
    },
    "& label": {
      ...Button,
      minWidth: 0,
      display: "inline-block",
      marginBottom: "15px",
      borderRadius: 0,
      color: stylesConfig.colors.secondaryAccentColorVariants.default,
      borderColor: stylesConfig.colors.secondaryAccentColorVariants.default,
    },
    "& .file-question__preview-list": {
      margin: `0 -${columnGap / 2}px`,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      width: "100%",
    },
    "& .file-question__preview-item": {
      position: "relative",
      maxWidth: `calc(33.3332% - ${columnGap}px)`,
      margin: `0 ${columnGap / 2}px`,
      marginBottom: "20px",
      "& img": {
        maxWidth: "100%",
      },
    },
    "& .file-question__validation-message": {
      color: globals.colors.white,
      fontSize: stylesConfig.typography.fontSize(0.9),
      fontWeight: 400,
      background: globals.colors.warning,
      letterSpacing: ".5px",
      lineHeight: "1.2em",
      width: "100%",
      margin: "auto",
      padding: "10px 20px",
      marginBottom: "10px",
      textAlign: "center",
    },
    "& .file-question__image-remove": {
      ...Button,
      fontWeight: 600,
      minWidth: 0,
      padding: 0,
      width: "25px",
      height: "25px",
      verticalAlign: "middle",
      textAlign: "center",
      position: "absolute",
      top: "5px",
      right: "5px",
      backgroundColor: "transparent",
      border: "none",
      "&:hover, &:active": {
        background: "transparent",
      },
      "& circle": {
        fill: globals.colors.white,
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        minWidth: "auto",
      },
    },
  },
};
